import { Box, SxProps } from '@mui/material';
import { PropsWithChildren } from 'react';

type Props = {
  color?: string;
  backgroundColor: string;
  borderColor?: string;
  width?: number | string;
};

/**
 * Dashboard chip, used in multiple places.
 *
 * Used instead of MUIs' Chip since we cannot set custom color to that component.
 */
export const Chip = ({ backgroundColor, color = 'white', borderColor = 'transparent', children, width }: PropsWithChildren<Props>) => {
  const borderWidth = borderColor === 'transparent' ? 0 : '1px';

  let additionalProps: SxProps = {};
  if (width !== undefined) {
    additionalProps = { ...additionalProps, width };
  }

  return (
    <Box
      sx={{
        display: 'inline-block',
        backgroundColor,
        color,
        border: `${borderWidth} solid`,
        borderColor,
        borderRadius: '1000px',
        fontSize: '0.875rem',
        px: 1,
        py: 0.375,
        textAlign: 'center',
        ...additionalProps,
      }}
    >
      {children}
    </Box>
  );
};
